export const optionsAreValid = (
  itemOptions: Array<{ _id: string; minQty?: number | null } | null> | null,
  selectedOptions: Record<string, Record<string, { qty: number; price: number }>>,
) => {
  if (!itemOptions) return true
  const optionsInvalid = itemOptions.some((option) => {
    if (!option?.minQty) return false
    const selectedOptionCategory = selectedOptions[option._id]
    if (!selectedOptionCategory) return true
    const totalSelected = Object.values(selectedOptionCategory).reduce(
      (total, val) => total + val.qty,
      0,
    )
    return totalSelected < option.minQty
  })
  return !optionsInvalid
}
